import {
  EMPTY_AUTH,
  EMPTY_USER,
  type GlobalStateCommandFactory,
} from 'components/GlobalState/GlobalStateModel';
import { refreshTokenExpirationLocalStorage } from 'components/GlobalState/refreshTokenExpirationLocalStorage';
import { connectSocket, disconnectSocket } from 'components/Socket/ipfSocket';

export const logout: GlobalStateCommandFactory = (cmdContext) => async () => {
  const userLoginStatus = cmdContext.getState().loginStatus;
  disconnectSocket();

  cmdContext.updateState((draft) => {
    draft.user = EMPTY_USER;
    draft.auth = EMPTY_AUTH;
    draft.loginStatus = 'LOGGED_OUT';
    draft.ipfNewVersion = null;
  });
  refreshTokenExpirationLocalStorage.setValue(null);

  // if user isn't logged in, we don't call logout endpoint because it needs valid refresh token
  if (userLoginStatus !== 'LOGGED_OUT') {
    await cmdContext.api.request<void>({
      url: '/auth/logout',
      method: 'POST',
    });
  }

  // reconnect socket on login page so we are able to display BSoD
  connectSocket();
};
